import {Component, OnInit, OnChanges} from '@angular/core';
import {AuthService} from './core/auth/auth.service';
import localePl from '@angular/common/locales/pl';
import {registerLocaleData} from '@angular/common';
import {NavigationHistoryService} from './services/NavigationHistoryService';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {LanguageService} from './services/language.service';
import {VersionCheckService} from './core/version/version-check.service';
import {PermissionsService} from './core/permissions/permissions.service';
registerLocaleData(localePl, 'pl-PL');

// @ts-ignore
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit, OnChanges {
  title = 'zadania';
  token: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private navigationHistoryService: NavigationHistoryService,
    private languageService: LanguageService,
    private versionCheck: VersionCheckService,
    private permissionsService: PermissionsService,
  ){
    // Pilnowanie, czy na serwerze nie ma nowszego frontendu (szczegoly w serwisie).
    this.versionCheck.start();
    // Przywrocenie jezyka przy KAZDYM starcie aplikacji (F5/Ctrl+F5), nie
    // tylko przy logowaniu. Bez tego TranslateModule startowal z defaultLanguage
    // 'pl' i kazde odswiezenie cofalo panel na polski, niezaleznie od wyboru
    // w selektorze i jezyka konta (regres Fernandy 10.08 - "cualquier
    // movimiento me quita la traduccion" + Google Translate na polskim UI).
    const storedUser = JSON.parse(localStorage.getItem('LoggedInUser') || 'null');
    this.languageService.init(storedUser?.language);
    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      let currentRoute = this.activatedRoute.root;
      let params = {};

      while (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
        params = {...params, ...currentRoute.snapshot.params};
      }

      const paramsObject = Object.keys(params).reduce((obj, key) => {
        return {...obj, [key]: params[key]};
      }, {});
      //this.navigationHistoryService.recordNavigation(event.url, paramsObject);
    });
  }

  ngOnInit() {
    this.token = this.authService.getToken();
    // Odswiezenie strony (F5) nie przechodzi przez login.component.ts, wiec
    // mapa uprawnien trzeba doladowac tez tutaj - sessionStorage z
    // PermissionsService daje natychmiastowy stan sprzed odswiezenia, refresh()
    // synchronizuje go w tle.
    if (this.authService.hasValidJwtShape()) {
      this.permissionsService.refresh();
    }
  }

  ngOnChanges() {
  }

  log( data ){
    console.log('token: ' + data);
  }
}
